export default __webpack_public_path__ + "static/media/editBlack.19aa592c.svg";